<template>
  <div class="l-empty">
    <img :src="imgSrc" alt="" :style="{width: imgWidth + 'px'}">
    <div class="noData">{{ $t('noDataEmpty') }}</div>
    <div class='text'>{{ text }}</div>
  </div>
</template>

<script>
export default {
  name: 'PtIndex',
  props: {
    text: {
      type: String,
      default: ''
    },
    imgSrc: {
      type: String,
      default: require('@/assets/img/bj_zanwushujv@2x.png')
    },
    imgWidth: {
      type: Number,
      default: 284
    },
    fontSize: {
      type: Number,
      default: 14
    },
    inline: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },

  mounted() {
    setTimeout(() => {
      console.log('imgSrc ----->', this.imgSrc)
    }, 500)
  },

  methods: {}
}
</script>

<style lang="less" scoped>
.l-empty {
  margin: 186px 0;
  img {
    height: auto;
  }
}
.inline .l-empty {
  margin: 0;
}
.noData{
  font-weight: 400;
  font-size: 14px;
  color: #333;
  margin-top: -30px;
  font-weight: 600;
}
.text{
  font-weight: 400;
  font-size: 12px;
  color: #0D2340;
  margin-top: 7px;
}
</style>
